// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"GenericHero_bgColor__Is0nJ","image":"GenericHero_image__31SCm","whiteText":"GenericHero_whiteText__yrW10"};